import React from 'react';
import AppRoutes from './router';
import { Header } from './componets.js/Header.js/Header';

const App = () => {
  return (
    <div>
      <AppRoutes/>
    
    </div>
  );
};

export default App;
